<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '' 
    };
  },
  methods: {
   add(){
    this.resetForm();
   },
   editSource(source) {
    this.id = source.id;
    this.name = source.name;
   },  

   async addUpdateSource(){
    this.errors = {};
    this.setLoading(true); 

    try{
     let response = []; 
     if(this.id){
      //UPDATE
      response = await axios.put('/lead-sources/update', {
       id: this.id, 
       name: this.name
      });
     }else{
      //CREATE
      response = await axios.post('/lead-sources/create', {
       name: this.name
      });
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.$emit('saved'); 
     this.closeModal('source_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteSource(){
   this.setLoading(true);
   try{
    const response = await axios.delete('/lead-sources/'+this.id+'/delete');
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="source_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Source</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="addUpdateSource">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Source Name</label>
                  <input type="text" class="form-control" v-model="name" />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">{{ id ? 'Edit' : 'Add' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteSource">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
